<template>
  <div>
    <div class="modal-container">
      <div ref="modalContainer">
        <div class="form-content-body">
          <div class="row m-0 p-0">
            <div
              class="
                col-md-12
                text-center
                modal-header
                pl-4
                pr-2
                align-items-center
              "
            >
              <div class="header-container row w-100">
                <h3 class="col-11 text-left">
                  <slot name="modal-title"></slot>
                </h3>
                <div class="close close-btn text-right col-1">
                  <img
                    src="../../assets/images/icon-close.svg"
                    class="cursor-pointer"
                    @click="close"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="prevBranchId !== branchId" >
        <div class="row no-gutters align-back-button">
          <div class="col-12 pl-4 pt-4">
                      <span @click="navigateToPreviousPage(prevBranchId)" class="solution-link " >
                        <font-awesome-icon icon="arrow-left" size="sm"/>
                          Back
                      </span>
          </div>
        </div>
      </div>
      <div class="modal-container-body pt-4" v-if="currentBranch.description">
        <div class="row">
          <div class="col-12">
            <div
              v-html="currentBranch.description"
              class="branch-description"
            ></div>
          </div>
        </div>
      </div>
      <div
        class="row modal-container-body row-eq-height card-group"
        v-if="currentBranch.actionType === 'BRANCH'"
      >
        <div
          class="col-md-6 col-12 p-3"
          v-for="innercard in decisionBranchesChildrenByCategoryId(
            currentBranch.id
          )"
          :key="innercard.id"
        >
          <a
            v-if="innercard.actionLink"
            class="modal-card-anchor"
            :href="innercard.actionLink"
            target="_blank"
            @click="trackActionLink(innercard.name, innercard.actionLink)"
          >
            <div
              v-bind:class="[
                innercard.description
                  ? 'align-items-left'
                  : 'align-items-center',
              ]"
              class="card decision-branch-card d-flex h-100 p-2"
            >
              <div class="card-body">
                {{ innercard.name }}

                <div
                  class="card-text branch-description"
                  v-html="innercard.description"
                ></div>
              </div>
            </div>
          </a>
          <a
            v-else
            class="modal-card-anchor"
            @click="navigateModal(innercard)"
            target="_blank"
          >
            <div
              v-bind:class="[
                innercard.description
                  ? 'align-items-left'
                  : 'align-items-center',
              ]"
              class="card solution-card decision-branch-card d-flex h-100 p-2"
            >
              <div class="card-body">
                {{ innercard.name }}

                <div
                    v-if="!innercard.hideDescription"
                  class="card-text branch-description"
                  v-html="innercard.description"
                ></div>
              </div>
            </div>
          </a>
        </div>
      </div>

      <div
        class="row modal-container-body pt-5"
        v-else-if="currentBranch.actionType == 'CONTENT'"
      >
        <div class="col-12">
          <div
            v-html="currentBranch.solutionContent"
            class="branch-description"
          ></div>
        </div>
      </div>

      <div class="row modal-container-body">
        <div class="col-12">
          <div>
            <div class="custom-card-title">
              {{ currentBranch.subSectionName }}
            </div>
            <ul class="child-list">
              <li
                class="pt-1 pb-1"
                v-for="resource in currentBranch.subSectionResources"
                :key="resource.id"
              >
                <a
                  @click="
                    trackSideSectionLink(currentBranch.subSectionName, resource)
                  "
                  target="_blank"
                  class="side-section-lnk"
                  :href="resource.value"
                  >{{ resource.title }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DecisionBranchModalMixin from "@/components/homepage/mixins/DecisionBranchModalMixin";
import MixpanelMixin from "@/mixins/MixpanelMixin";

export default {
  props: {
    branchId: String,
    prevBranchId: String
  },
  mixins: [DecisionBranchModalMixin, MixpanelMixin],
  methods: {
    close() {
      this.$emit("close");
    },
    navigateToPreviousPage(id) {
      this.$emit("navigateModal", id, true);
    },
    navigateModal(innercard) {
      this.trackActionLink(innercard.name, "MODAL")
      this.$emit("navigateModal", innercard.id);
    },
    trackSideSectionLink(sectionName, resource) {
      this.trackFeatureSelected("MODAL - " + this.branchDisplayName+ " - " +sectionName, resource.title, resource.value);
    },
    trackActionLink(actionName, actionLink) {
      this.trackFeatureSelected(
        "MODAL - " + this.branchDisplayName,
        actionName,
        actionLink
      );
    }
  },
};
</script>
<style scoped>
.card:hover {
  background: #f0f3f4;
}

.card {
  cursor: pointer;
}
.modal-container {
  min-height: 500px;
  font-size: 16px;
  background: #ffffff;
}
.header-container {
  font-family: artifaktElementBold;
}

.modal-container-body {
  background-color: #fff;
  padding: 0px 30px 30px 20px;
}
.branch-description {
  font-size: 16px;
  font-family: artifaktElementRegular !important;
}

.decision-branch-card {
  border: 1px solid #b0b0b0 !important;
}

.modal-card-anchor {
  color: #000 !important;
  cursor: pointer;
  font-family: "artifaktElementBold";
}

.modal-header{
  height: 100%;
}
</style>
